// do NOT indent code
// replace :url in component
export const STANDINGS_IFRAME: string =
`<iframe
  id="iframe-standings-auto"
  src=":url"
  width="100%"
  height="300"
  frameborder="0"
  scrolling="no"
  style="border: none; overflow: hidden;">
</iframe>

<script>
  window.addEventListener("message", function(e) {
    var iframe = document.getElementById("iframe-standings-auto");
    if (e.data && e.data.iframeStandingsHeight) {
      iframe.style.height = e.data.iframeStandingsHeight + "px";
    }
  });
</script>`;